import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { PROGRAMS } from '../data/mock';
import { InlineText, InlineImage } from './InlineEditable';

export default function ProgramsSection() {
  const [active, setActive] = useState(0);
  return (
    <section className="bg-cream-100 relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <InlineText settingKey="home_programs_kicker" fallback="Programlarımız" as="div"
              className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-semibold" />
            <InlineText settingKey="home_programs_title"
              fallback={'Bütünsel destek, <span class="italic">dokunan</span> etki.'}
              as="h2" html multiline
              className="font-display text-4xl md:text-5xl lg:text-[56px] mt-4 leading-[1.02] text-ink-600 max-w-3xl" />
          </div>
          <Link to="/projeler" className="inline-flex items-center gap-2 text-ink-600 font-medium hover:gap-3 transition-all">
            Tüm projeler <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          {/* Tabs */}
          <div className="lg:col-span-5 flex flex-col gap-3">
            {PROGRAMS.map((p, i) => {
              const n = i + 1;
              return (
                <div
                  key={p.id}
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  className={`group text-left p-6 md:p-7 rounded-2xl border transition-all cursor-pointer ${
                    active === i
                      ? 'bg-ink-600 border-ink-600 text-cream shadow-xl'
                      : 'bg-white border-ink-100 text-ink-600 hover:border-ink-300'
                  }`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1 min-w-0">
                      <InlineText settingKey={`home_program_${n}_kicker`} fallback={p.kicker} as="div"
                        className={`text-[10px] uppercase tracking-widest mb-2 ${active === i ? 'text-gold' : 'text-ink-400'}`} />
                      <InlineText settingKey={`home_program_${n}_title`} fallback={p.title} as="div"
                        className="font-display text-2xl md:text-[28px] leading-tight" />
                    </div>
                    <div className={`w-9 h-9 shrink-0 rounded-full grid place-items-center ${active === i ? 'bg-gold text-ink-700' : 'bg-ink-50 text-ink-600'}`}>
                      <span className="font-display text-sm font-semibold tabular">0{n}</span>
                    </div>
                  </div>
                  <InlineText settingKey={`home_program_${n}_description`} fallback={p.description} as="div" multiline
                    className={`mt-3 text-sm leading-relaxed ${active === i ? 'text-cream/75' : 'text-ink-500'}`} />
                </div>
              );
            })}
          </div>

          {/* Preview */}
          <div className="lg:col-span-7">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] md:aspect-[5/6] shadow-2xl shadow-ink-900/20 bg-ink-700">
              {PROGRAMS.map((p, i) => {
                const n = i + 1;
                return (
                  <div key={p.id} className={`absolute inset-0 transition-opacity duration-500 ${active === i ? 'opacity-100 z-10' : 'opacity-0 pointer-events-none'}`}>
                    <InlineImage settingKey={`home_program_${n}_image`} fallback={p.image} alt={p.title}
                      className="w-full h-full object-cover" style={{ width: '100%', height: '100%' }} />
                  </div>
                );
              })}
              <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 via-ink-900/15 to-transparent pointer-events-none z-20" />
              <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10 text-cream z-30">
                <InlineText settingKey={`home_program_${active + 1}_kicker`} fallback={PROGRAMS[active].kicker} as="div"
                  className="text-[10px] uppercase tracking-widest text-gold mb-2" />
                <InlineText settingKey={`home_program_${active + 1}_title`} fallback={PROGRAMS[active].title} as="h3"
                  className="font-display text-3xl md:text-4xl leading-tight" />
                <InlineText settingKey={`home_program_${active + 1}_description`} fallback={PROGRAMS[active].description} as="p" multiline
                  className="mt-3 max-w-xl text-cream/85 text-sm md:text-base" />
                <Link to={PROGRAMS[active].link} className="mt-6 inline-flex items-center gap-2 bg-cream text-ink-600 rounded-full px-5 h-11 text-sm font-semibold hover:bg-gold transition-colors">
                  Detayı Gör <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
